import { FC } from 'react';
import { Label, TextInput, TextInputProps } from '@silverfort/sf-components';

interface Props extends TextInputProps {
    label: string;
    labelTooltip?: string;
    errorMessage?: string;
}

const SettingsTextInput: FC<Props> = ({ label, labelTooltip, errorMessage, ...textInputProps }) => (
    <div className="flex flex-col">
        <Label className="mb-2" text={label} tooltipInfo={labelTooltip} />
        <TextInput {...textInputProps} validationMessage={errorMessage} />
    </div>
);

export default SettingsTextInput;
